<template>
    <div>
        <cardWrapper>
            <h6>{{$t('message.injurys_data')}}</h6>
            <injurys_table_form></injurys_table_form>
        </cardWrapper>
        <cardWrapper>
            <h6>{{$t('message.add_info')}} ({{$t('message.injury_files_button_text')}})</h6>
            <files_table_form :skip="false"></files_table_form>
        </cardWrapper>
    </div>


</template>

<script>
import injurys_table_form from '@/forms/injurys_table_form'
import files_table_form from '@/forms/files_table_form'
import cardWrapper from '@/components/cardWrapper'

export default {
  name: 'pcard',
  data () {
        return {
        }
  },
  components: {
        cardWrapper,
        injurys_table_form,
        files_table_form,
  },
}
</script>

